export default function Skeleton() {
  return <div className='absolute left-0 top-0 h-full w-full bg-white' data-sentry-component="Skeleton" data-sentry-source-file="skeleton.tsx">
            <div className='flex h-full w-full items-center justify-between'>
                <div className='h-[90%] w-[5%] animate-pulse rounded-l bg-gray-100 lg:w-[3%]'></div>
                <div className='h-full w-[81%] animate-pulse rounded bg-gray-100 lg:w-[91%]'></div>
                <div className='h-[90%] w-[5%] animate-pulse rounded-r bg-gray-100 lg:w-[3%]'></div>
            </div>
        </div>;
}